import {Device} from '@twilio/voice-sdk';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.us';

if($('#dialer').length) {
    $(document).ready(function() {
        let audioContext = new (window.AudioContext || window.webkitAudioContext)();

        // DTMF frequencies for each number button
        let dtmfFrequencies = {
            "1": 697,
            "2": 697,
            "3": 697,
            "4": 770,
            "5": 770,
            "6": 770,
            "7": 852,
            "8": 852,
            "9": 852,
            "*": 941,
            "0": 941,
            "#": 941
        };

        // Get all the number buttons
        let numberButtons = document.querySelectorAll(".number-button");
        const speakerDevices = document.getElementById("speaker-devices");
        const ringtoneDevices = document.getElementById("ringtone-devices");
        const outputVolumeBar = document.getElementById("output-volume");
        const inputVolumeBar = document.getElementById("input-volume");
        const volumeIndicators = document.getElementById("volume-indicators");
        const callButton = document.getElementById("button-call");
        const callInputButton = document.getElementById("button-call-input");
        const outgoingCallHangupButton = document.getElementById("button-hangup-outgoing");
        const callControlsDiv = document.getElementById("call-controls");
        const audioSelectionDiv = document.getElementById("output-selection");
        const getAudioDevicesButton = document.getElementById("get-devices");
        const logDiv = document.getElementById("log");
        const phoneNumberSelect = document.getElementById("phone-number");
        const phoneNumberInput = document.getElementById("phone-number-input");
        const startupButton = document.getElementById("startup-button");
        const recordButton = document.getElementById("record-button");
        const playbackButton = document.getElementById("playback-button");
        const playRecordingButton = document.getElementById("button-play-recording");
        const numberPad = document.getElementById("number-pad");

        let device;
        let token;

        let cleave = new Cleave('#phone-number-input', {
            phone: true,
            phoneRegionCode: 'US'
        });

        // Event Listeners
        $(".number-button").on("click", function() {
            // quick background color change
            $(this).addClass("bg-info");
            setTimeout(() => {
                $(this).removeClass("bg-info");
            }, 100);

            // play sound
            var sound = new Audio($(this).data("sound"));
            sound.play();

            // Send the clicked number through the call
            if(device && device._activeCall) {
                device._activeCall.sendDigits($(this).text());
            }
        });

        // Add a click event listener to each number button
        numberButtons.forEach(button => {
            button.addEventListener("click", function() {
                // Get the DTMF frequency for the clicked button
                let frequency = dtmfFrequencies[this.textContent];

                // Create an OscillatorNode
                let oscillator = audioContext.createOscillator();
                oscillator.type = 'sine';
                oscillator.frequency.value = frequency; // value in hertz

                // Connect the oscillator to the context's destination (the speakers)
                oscillator.connect(audioContext.destination);

                // Start the oscillator
                oscillator.start();

                // Stop the oscillator after a short delay
                setTimeout(() => {
                    oscillator.stop();
                }, 200);
            });
        });

        callButton.onclick = (e) => {
            let number = phoneNumberSelect.value;
            e.preventDefault();
            makeOutgoingCall(number);
        };
        callInputButton.onclick = (e) => {
            let number = phoneNumberInput.value;
            e.preventDefault();
            makeOutgoingCall(number);
        };

        recordButton.onclick = (e) => {
            e.preventDefault();
            createRecording();
        }

        playbackButton.onclick = (e) => {
            e.preventDefault();
            playbackRecording();
        }

        playRecordingButton.onclick = (e) => {
            e.preventDefault();
            playOutgoingRecording();
        }


        getAudioDevicesButton.onclick = getAudioDevices;
        speakerDevices.addEventListener("change", updateOutputDevice);
        ringtoneDevices.addEventListener("change", updateRingtoneDevice);


        // SETUP STEP 1:
        // Browser client should be started after a user gesture
        // to avoid errors in the browser console re: AudioContext
        startupButton.addEventListener("click", startupClient);

        /**
         * Asynchronously starts up the client, requesting access token and initializing the device.
         *
         * @return {Promise<void>} A promise that resolves when the client startup process is complete
         */
        async function startupClient() {
            // Check for phone number variable
            if(!employeeNumber) {
                log("Employee number not found.");
                return;
            }

            log("Requesting Access Token...");

            try {
                const data = await $.getJSON(route("tenant.dialer.token"));
                if(!data.token) {
                    log("An error occurred: " + data.error);
                    return;
                }
                log("Got a token.");
                token = data.token;
                setClientNameUI(data.identity);
                intitializeDevice();
            } catch(err) {
                log("An error occurred. Contact the administrator is this issue persists.");
            }
        }

        /**
         * Initializes the device by removing the "hide" class from logDiv, logging an initialization message,
         * creating a new Device instance with specified token and options, adding listeners to the device, and
         * registering the device.
         */
        function intitializeDevice() {
            logDiv.classList.remove("hide");
            log("Initializing device");
            device = new Device(token, {
                logLevel: 1,
                // Set Opus as our preferred codec. Opus generally performs better, requiring less bandwidth and
                // providing better audio quality in restrained network conditions.
                codecPreferences: ["opus", "pcmu"]
            });

            addDeviceListeners(device);

            // Register the device
            device.register();
        }

        /**
         * Add event listeners for the device.
         *
         * @param {type} device - The device to add listeners to
         * @return {type} undefined
         */
        function addDeviceListeners(device) {
            device.on("registered", function() {
                log("Ready to make calls!");
                callControlsDiv.classList.remove("hide");
            });

            device.on("error", function(error) {

                // Check the error code if it is token related
                if(error.code === 31205 || error.code === 20104 || error.code === 20101) {
                    log("Token expired. Attempting to reinitialize device ...");
                    startupButton.click();
                } else {
                    log("Error: " + error.message);
                }
            });

            device.audio.on("deviceChange", updateAllAudioDevices.bind(device));

            // Show audio selection UI if it is supported by the browser.
            if(device.audio.isOutputSelectionSupported) {
                audioSelectionDiv.classList.remove("hide");
            }
        }

        /**
         * Asynchronously makes an outgoing call.
         *
         * @return {void}
         */
        async function makeOutgoingCall(number) {
            if(!number) {
                log("No phone number selected.");
                return;
            }
            if(!employeeNumber) {
                log("Employee number not found.");
                return;
            }
            var params = {
                // get the phone number to call from the DOM
                To: number,
                From: employeeNumber,
                Action: "call",
                EmployeeId: employeeId
            };

            if(device) {
                log(`Attempting to call ${params.To} ...`);

                // Twilio.Device.connect() returns a Call object
                try {
                    // Attempt to establish a connection
                    const call = await device.connect({params});

                    // add listeners to the Call
                    // "accepted" means the call has finished connecting and the state is now "open"
                    call.on("accept", updateUIAcceptedOutgoingCall);
                    call.on("disconnect", (call) => {
                        updateUIDisconnectedOutgoingCall()
                        logCallDetails(call);
                    });
                    call.on("cancel", updateUIDisconnectedOutgoingCall);

                    outgoingCallHangupButton.onclick = () => {
                        log("Hanging up ...");
                        call.disconnect();
                    };

                } catch(error) {
                    // Check if the error is due to an expired token
                    if(error.message === 'Expired token' || error.code === 20104 || error.code === 31205 || error.code === 20101) {
                        startupButton.click();

                        // Retry the connection
                        const call = await device.connect({params});

                    } else {
                        // Handle other errors
                        console.error('Failed to connect: ', error);
                    }
                }
            } else {
                log("Unable to make call.");
            }
        }

        /**
         * Asynchronously creates a recording based on the employee number.
         *
         * @return {void}
         */
        async function createRecording() {
            if(!employeeNumber) {
                log("Employee number not found.");
                return;
            }
            let params = {
                // get the phone number to call from the DOM
                From: employeeNumber,
                Action: "record"
            };

            if(device) {
                log(`Trying to record...`);

                // Twilio.Device.connect() returns a Call object
                const call = await device.connect({params});

                // add listeners to the Call
                // "accepted" means the call has finished connecting and the state is now "open"
                call.on("accept", updateUIAcceptedOutgoingCall);
                call.on("disconnect", updateUIDisconnectedOutgoingCall);
                call.on("cancel", updateUIDisconnectedOutgoingCall);

                outgoingCallHangupButton.onclick = () => {
                    log("Hanging up ...");
                    call.disconnect();
                };

            } else {
                log("Unable to record.");
            }
        }

        /**
         * Asynchronously plays back a recording based on the employee number.
         *
         * @return {undefined}
         */
        async function playbackRecording() {
            if(!employeeNumber) {
                log("Employee number not found.");
                return;
            }
            let params = {
                // get the phone number to call from the DOM
                From: employeeNumber,
                Action: "playback"
            };

            if(device) {
                log(`Playing recording...`);

                // Twilio.Device.connect() returns a Call object
                const call = await device.connect({params});

                // add listeners to the Call
                // "accepted" means the call has finished connecting and the state is now "open"
                call.on("accept", updateUIAcceptedOutgoingCall);
                call.on("disconnect", updateUIDisconnectedOutgoingCall);
                call.on("cancel", updateUIDisconnectedOutgoingCall);

                outgoingCallHangupButton.onclick = () => {
                    log("Hanging up ...");
                    call.disconnect();
                };

            } else {
                log("Unable to playback recording.");
            }
        }

        /**
         * Plays the outgoing recording for the active call, if available.
         */
        function playOutgoingRecording() {
            if(device) {
                // Check for an active call
                if(device._activeCall) {
                    // Make the request to play the recording for the active call
                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    })
                    $.ajax({
                        url: "/dialer/sendRecording",
                        type: "POST",
                        data: {
                            callSid: device._activeCall.parameters.CallSid
                        },
                        success: function(response) {
                            log(response)
                        }
                    })

                } else {
                    log("No call in progress.");
                }
            } else {
                log("Device not initiated.")
            }
        }

        function updateUIAcceptedOutgoingCall(call) {
            log("Call in progress ...");
            callButton.disabled = true;
            callInputButton.disabled = true;
            playRecordingButton.disabled = false;
            outgoingCallHangupButton.classList.remove("hide");
            volumeIndicators.classList.remove("hide");
            numberPad.style.display = "block";
            bindVolumeIndicators(call);
        }

        function updateUIDisconnectedOutgoingCall() {
            log("Call disconnected.");
            callButton.disabled = false;
            callInputButton.disabled = false;
            outgoingCallHangupButton.classList.add("hide");
            volumeIndicators.classList.add("hide");
            numberPad.style.display = "none";
        }


        // Activity log
        function log(message) {
            logDiv.innerHTML += `<p class="log-entry">&gt;&nbsp; ${message} </p>`;
            logDiv.scrollTop = logDiv.scrollHeight;
        }

        function setClientNameUI(clientName) {
            var div = document.getElementById("client-name");
            div.innerHTML = `Your client name: <strong>${clientName}</strong>`;
        }


        // AUDIO CONTROLS

        async function getAudioDevices() {
            await navigator.mediaDevices.getUserMedia({audio: true});
            updateAllAudioDevices.bind(device);
        }

        function updateAllAudioDevices() {
            if(device) {
                updateDevices(speakerDevices, device.audio.speakerDevices.get());
                updateDevices(ringtoneDevices, device.audio.ringtoneDevices.get());
            }
        }

        function updateOutputDevice() {
            const selectedDevices = Array.from(speakerDevices.children)
                .filter((node) => node.selected)
                .map((node) => node.getAttribute("data-id"));

            device.audio.speakerDevices.set(selectedDevices);
        }

        function updateRingtoneDevice() {
            const selectedDevices = Array.from(ringtoneDevices.children)
                .filter((node) => node.selected)
                .map((node) => node.getAttribute("data-id"));

            device.audio.ringtoneDevices.set(selectedDevices);
        }

        function bindVolumeIndicators(call) {
            call.on("volume", function(inputVolume, outputVolume) {
                var inputColor = "red";
                if(inputVolume < 0.5) {
                    inputColor = "green";
                } else if(inputVolume < 0.75) {
                    inputColor = "yellow";
                }

                inputVolumeBar.style.width = Math.floor(inputVolume * 300) + "px";
                inputVolumeBar.style.background = inputColor;

                var outputColor = "red";
                if(outputVolume < 0.5) {
                    outputColor = "green";
                } else if(outputVolume < 0.75) {
                    outputColor = "yellow";
                }

                outputVolumeBar.style.width = Math.floor(outputVolume * 300) + "px";
                outputVolumeBar.style.background = outputColor;
            });
        }

        // Update the available ringtone and speaker devices
        function updateDevices(selectEl, selectedDevices) {
            selectEl.innerHTML = "";

            device.audio.availableOutputDevices.forEach(function(device, id) {
                var isActive = selectedDevices.size === 0 && id === "default";
                selectedDevices.forEach(function(device) {
                    if(device.deviceId === id) {
                        isActive = true;
                    }
                });

                var option = document.createElement("option");
                option.label = device.label;
                option.setAttribute("data-id", id);
                if(isActive) {
                    option.setAttribute("selected", "selected");
                }
                selectEl.appendChild(option);
            });
        }

        function logCallDetails(call) {
            let details = {};

            // Loop through custom parameters Map
            for(let [key, value] of call.customParameters) {
                // Set details object with key value pairs
                details[key] = value;
            }

            // Add the callSid to the details object
            details.callSid = call.parameters.CallSid;

            // Trigger the custom event to add a log to a ticket
            let event = new CustomEvent("dialerDisconnected", {
                detail: details
            });
            document.dispatchEvent(event);
        }
    });
}

